export default {"src":"/_next/static/media/mic.0b363a96.svg","height":16,"width":13,"blurWidth":0,"blurHeight":0};